module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.jobs.length) ? _c('div', {
    staticClass: "block"
  }, _vm._l((_vm.jobs), function(job) {
    return _c('job-list-item', {
      key: job.id,
      attrs: {
        "job": job
      }
    })
  }), 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c99f5268","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/jobs/JobList.vue
// module id = 756
// module chunks = 1